import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
var DefaultCard = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.paddingClassName, paddingClassName = _b === void 0 ? 'p-4' : _b;
    return (_jsx("div", { className: clsx('overflow-hidden bg-white rounded-xl shadow-xl flex flex-col', className, paddingClassName), children: children }));
};
var Header = function (_a) {
    var children = _a.children, className = _a.className, showBorder = _a.showBorder;
    return (_jsx("div", { className: clsx(showBorder && 'pb-2 mb-2 border-b border-zinc-200', className), children: children }));
};
var Body = function (_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", { className: className, children: children }));
};
DefaultCard.Header = Header;
DefaultCard.Body = Body;
export { DefaultCard as default };
